import { render, staticRenderFns } from "./chufang.vue?vue&type=template&id=d1eb1d1c&scoped=true&"
import script from "./chufang.vue?vue&type=script&lang=js&"
export * from "./chufang.vue?vue&type=script&lang=js&"
import style0 from "./chufang.vue?vue&type=style&index=0&id=d1eb1d1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1eb1d1c",
  null
  
)

export default component.exports